module.exports = __webpack_public_path__ + "static/media/48375389_1672565639513929_8625599635353763840_o.1bf8d81f.png";